import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

/* Sections */
import { LaravelCategories, SLUG } from "helpers/helpers";
import { Box } from "@mui/material";
import { getProducts } from "utils/LaravelApi/LaravelAPI";
import Kat from "./Categories/Kat";
import Enf from "./Categories/Enf";
import Cart from "./Categories/Cart";

export default function NewCatalogue() {
  const { typeSlug, brand, model, variant } = useParams();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const category = LaravelCategories[SLUG[typeSlug]];
    const fetchProducts = async () => {
      const products = await getProducts(category, brand, model, variant);
      if (products.success) {
        setProducts(products.data);
      }
    };
    fetchProducts();
    //eslint-disable-next-line
  }, []);

  if (products.length === 0) return <NoProducts />;

  if (SLUG[typeSlug] === "KAT") return <Kat catalogue={products} />;
  if (SLUG[typeSlug] === "Enf") return <Enf catalogue={products} />;
  if (SLUG[typeSlug] === "Cart") return <Cart catalogue={products} />;
}

function NoProducts() {
  return (
    <Box
      component="div"
      sx={{
        color: "#7F7F7F",
        fontSize: { xs: "10px", sm: "50px" },
        fontWeight: "700",
        paddingBottom: "30px",
        paddingTop: "30px",
      }}
    >
      Selecciona otra marca y modelo
    </Box>
  );
}
